import styled from 'styled-components';

export const SocialIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
`;
